import React from "react";
import styles from "./WalletActiveScreen.module.scss";
import { CustomerWalletDetails } from "../models/CustomerWalletDetails";
import { WalletBalanceCard } from "../wallet-balance-card/WalletBalanceCard";
import { ManagePaymentCards } from "../manage-payment-cards/ManagePaymentCards";
import { WalletTransactionsPanel } from "../wallet-transactions-panel/WalletTransactionsPanel";
import Can from "../../../../guards/Can";
import { CustomerPermissions } from "../../../../model/permissions/permissions";

interface Props {
	data: CustomerWalletDetails;
	showCreatedBanner: boolean;
}

export const WalletActiveScreen: React.FC<Props> = ({ data, showCreatedBanner }) => {
	return (
		<div className={styles.layout}>
			<div className={styles.leftColumn}>
				<Can permission={CustomerPermissions.ViewWallets}>
					<WalletBalanceCard data={data} showCreatedBanner={showCreatedBanner} />
				</Can>
				<ManagePaymentCards />
			</div>
			<div className={styles.rightColumn}>
				<WalletTransactionsPanel />
			</div>
		</div>
	);
};
